import * as R from 'ramda';

export const format = (columns, data) => {
  const headers = R.map(R.prop('label'))(columns);
  const columnsAndHeaders = R.map(({row}) => [headers, row])(data);
  return R.map(columnHeaderPair => R.zipObj(...columnHeaderPair))(columnsAndHeaders);
};
